export const VARIANTS = ['primary', 'orga', 'certif', 'admin', 'modulix'];

export const MODAL_VARIANTS = ['default', 'orga', 'certif'];
